import React, { useState } from 'react';
import { Button } from '@mui/material';
import FingerprintIcon from '@mui/icons-material/Fingerprint';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { useDispatch, useSelector } from 'react-redux';
import { updateJourneyEvents } from '../../CustomerJourneyDetails/CustomerJourneyDetails';
import { initiateEkyc } from '../../Utils/api';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

export default function EkycStep() {
    const dispatch = useDispatch();
    const customerDetails = useSelector((state) => state?.customerJourneyDetails?.customerDetails);
    const ekyc = useSelector((state) => state?.customerJourneyDetails?.journeySteps?.ekyc_verified);

    const [loader, setLoader] = useState(false);
    const [redirectUrl, setRedirectUrl] = useState(null);
    const [confirmLoader, setConfirmLoader] = useState(false);
    const [aadhaarLast4, setAadhaarLast4] = useState('');
    const [aadhaarError, setAadhaarError] = useState('');
    const navigate = useNavigate();

    const handleStartEkyc = async () => {
        if (loader) return;

        // Validate Aadhaar last 4 digits
        if (!/^\d{4}$/.test(aadhaarLast4)) {
            setAadhaarError('Please enter the last 4 digits of your Aadhaar number.');
            return;
        }
        setAadhaarError('');
        setLoader(true);
        try {
            const param = {
                profile_id: customerDetails?.profileId,
                profileId: customerDetails?.profileId,
                aadhaar_no: aadhaarLast4,
                event_name: 'ekyc_initiated',
                run_ekyc_flag: 1
            };
            const response = await initiateEkyc(param);
            console.log("response", response, response?.data?.data?.ekyc_url);

            if (response?.data?.status == 1) {
                const url = response?.data?.data?.ekyc_url ?? '';

                if (url) {
                    setRedirectUrl(url);
                    // window.open(url, '_blank');
                    window.location.href = url;
                    //navigate(url);

                    toast.success('eKYC portal opened. Please complete verification and return here.');
                } else {
                    toast.error('Redirect URL not received. Please try again.');
                }
            } else {
                toast.error(response?.data?.message || 'Failed to initiate eKYC. Please try again.');
            }
        } catch (error) {
            console.error('eKYC initiate error:', error);
            toast.error('Error initiating eKYC. Please try again.');
        } finally {
            setLoader(false);
        }
    };

    const handleConfirmEkyc = () => {
        setConfirmLoader(true);
        dispatch(updateJourneyEvents({
            ekyc_verified: 1,
        }));
        toast.success('eKYC verified successfully!');
        // navigate('/journey/congratulations');
        setConfirmLoader(false);
    };

    return (
        <div className="box-height" style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'center', width: '100%' }}>
            <div className="wraper-right-box" style={{ width: '100%' }}>

                {/* Header */}
                <div className="d-flex align-items-center gap-2 mb-4">
                    <div className="bor rounded-circle">
                        <ArrowForwardIosIcon style={{ fontSize: '30px', color: '#9a141a' }} />
                    </div>
                    <h4 className="pl-5 fontstyle mb-0">eKYC Verification</h4>
                </div>

                <div className="pl-45">
                    <p className="fw-normal mb-3" style={{ maxWidth: '550px' }}>
                        Complete your Know Your Customer (KYC) digitally via our secure third-party verification portal.
                        Enter the last 4 digits of your Aadhaar, then click "Start eKYC" to open the verification portal.
                    </p>

                    {/* Aadhaar Last 4 Digit Input */}
                    {ekyc != 1 && (
                        <div className="mb-4" style={{ maxWidth: '380px' }}>
                            <p className="mb-1 fw-medium fs-6 fontstyle">
                                Last 4 Digits of Aadhaar <span className="text-danger">*</span>
                            </p>
                            <div className="input-group">
                                <span className="input-group-text solid-border" style={{ background: redirectUrl ? '#dee2e6' : '#fff' }}>
                                    <FingerprintIcon style={{ color: '#9a141a' }} />
                                </span>
                                <input
                                    id="input-aadhaar-last4"
                                    type="text"
                                    inputMode="numeric"
                                    maxLength={4}
                                    placeholder="e.g. 1234"
                                    value={aadhaarLast4}
                                    onChange={(e) => {
                                        const val = e.target.value.replace(/[^0-9]/g, '');
                                        setAadhaarLast4(val);
                                        if (aadhaarError) setAadhaarError('');
                                    }}
                                    disabled={!!redirectUrl}
                                    className="form-control solid-border"
                                    style={{ maxWidth: '120px', height: '45px', letterSpacing: '8px', fontSize: '18px', fontWeight: '600' }}
                                />
                            </div>
                            {aadhaarError && (
                                <span style={{ color: 'red', fontSize: '13px', marginTop: '4px', display: 'block' }}>
                                    {aadhaarError}
                                </span>
                            )}
                        </div>
                    )}

                    {/* Step indicators */}
                    <div className="d-flex flex-column gap-3 mb-4" style={{ maxWidth: '500px' }}>

                        {/* Step 1 */}
                        <div className="d-flex align-items-center gap-3 p-3 rounded"
                            style={{ background: redirectUrl ? '#f0faf0' : '#fef9f9', border: `1px solid ${redirectUrl ? '#28a745' : '#9a141a'}` }}>
                            <div style={{
                                width: '32px', height: '32px', borderRadius: '50%',
                                background: redirectUrl ? '#28a745' : '#9a141a',
                                display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0
                            }}>
                                {redirectUrl
                                    ? <CheckCircleOutlineIcon style={{ color: '#fff', fontSize: '20px' }} />
                                    : <span style={{ color: '#fff', fontWeight: 'bold', fontSize: '14px' }}>1</span>
                                }
                            </div>
                            <div>

                                <p className="mb-0 fw-medium fontstyle">Open eKYC Portal</p>
                                <span className="text-muted" style={{ fontSize: '13px' }}>
                                    {redirectUrl ? 'Portal opened in new tab' : 'Click "Start eKYC" to open the verification portal'}
                                </span>
                            </div>
                        </div>

                        {/* Step 2 */}
                        <div className="d-flex align-items-center gap-3 p-3 rounded"
                            style={{ background: ekyc == 1 ? '#f0faf0' : '#f8f9fa', border: `1px solid ${ekyc == 1 ? '#28a745' : '#dee2e6'}` }}>
                            <div style={{
                                width: '32px', height: '32px', borderRadius: '50%',
                                background: ekyc == 1 ? '#28a745' : '#6c757d',
                                display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0
                            }}>
                                {ekyc == 1
                                    ? <CheckCircleOutlineIcon style={{ color: '#fff', fontSize: '20px' }} />
                                    : <span style={{ color: '#fff', fontWeight: 'bold', fontSize: '14px' }}>2</span>
                                }
                            </div>
                            <div>
                                <p className="mb-0 fw-medium fontstyle">Confirm Completion</p>
                                <span className="text-muted" style={{ fontSize: '13px' }}>
                                    {ekyc == 1 ? 'eKYC completed successfully' : 'Return here after completing eKYC in the portal'}
                                </span>
                            </div>
                        </div>
                    </div>

                    {/* Action Buttons */}
                    <div className="d-flex flex-wrap gap-3 mt-3">

                        {/* Start / Retry eKYC */}
                        {ekyc != 1 && (
                            <Button
                                id="btn-start-ekyc"
                                variant="contained"
                                size="large"
                                onClick={handleStartEkyc}
                                disabled={loader}
                                startIcon={<FingerprintIcon />}
                                endIcon={<OpenInNewIcon />}
                                style={{ background: '#9a141a', textTransform: 'none', fontWeight: '600' }}
                            >
                                {loader ? 'Opening...' : redirectUrl ? 'Retry eKYC' : 'Start eKYC'}
                            </Button>
                        )}

                        {/* Confirm completion — shown after redirect URL received */}
                        {redirectUrl && ekyc != 1 && (
                            <Button
                                id="btn-confirm-ekyc"
                                variant="outlined"
                                size="large"
                                onClick={handleConfirmEkyc}
                                disabled={confirmLoader}
                                startIcon={<CheckCircleOutlineIcon />}
                                style={{ borderColor: '#28a745', color: '#28a745', textTransform: 'none', fontWeight: '600' }}
                            >
                                I have completed eKYC
                            </Button>
                        )}

                        {/* Already done */}
                        {ekyc == 1 && (
                            <div className="d-flex align-items-center gap-2" style={{ color: '#28a745' }}>
                                <CheckCircleOutlineIcon />
                                <span className="fw-semibold">eKYC Verified Successfully!</span>
                            </div>
                        )}
                    </div>

                    {/* Info note */}
                    <p className="mt-4 text-muted" style={{ fontSize: '13px', maxWidth: '500px' }}>
                        <strong>Note:</strong> After completing eKYC in the portal, please return to this page and click
                        "I have completed eKYC" to proceed to the Thank You page.
                    </p>
                </div>
            </div>
        </div>
    );
}
